// // app/helpers/interactions/handlersWheel.js

export function makeHandleWheel(ctx) {
  return function handleWheel(opt) {
    return;
    const canvas = ctx.fabricCanvasRef.current;
    if (!canvas) {
      console.warn("⚠️ No canvas attached to ctx yet");
      return;
    }

    // Calculate zoom factor
    let zoom = canvas.getZoom();
    var delta = opt.e.deltaY;
    zoom *= 0.999 ** delta;

    // Limit zoom level
    zoom = Math.max(1, Math.min(2, zoom)); // adjust min and max zoom levels

    // Reset zoom and pan when zooming out to minimum limit
    if (zoom === 1 && delta > 0) {
      canvas.setViewportTransform([1, 0, 0, 1, 0, 0]); // reset pan
    }

    // Zoom around cursor
    if (zoom !== canvas.getZoom()) {
      canvas.zoomToPoint(
        {
          x: opt.pointer.x,
          y: opt.pointer.y,
        },
        zoom
      );
    }
    canvas.renderAll();
  };
}
